import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

interface CommonModalProps {
    isOpen: boolean;
    onClose: () => void;
    header?: string;
    content?: React.ReactNode;
    footer?: React.ReactNode;
}

const CommonModal: React.FC<CommonModalProps> = ({
    isOpen,
    onClose,
    header,
    content,
    footer,
}) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{ style: { width: '75vw', maxWidth: '75vw' } }}
        >
            <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h3>{header}</h3>
                <IconButton
                    onClick={onClose}
                    size="small"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            {content && <DialogContent dividers>{content}</DialogContent>}
            {footer && <DialogActions>{footer}</DialogActions>}
        </Dialog>
    );
};

export default CommonModal;
